import React, { useEffect, useState } from "react";
import { Row, Col, Button, Select, Divider } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { updateDrillDowns } from "../../../../../redux/editorSlice";
import "./HyperLink.css";
import DeleteIcon from "../../../../../assets/icons/delete-icon.svg";
const { Option } = Select;

export default function HyperLink(props) {
  const dispatch = useDispatch();
  const boardsState = useSelector((state) => state.boards);
  const editorState = useSelector((state) => state.editor);
  const [hyperLinkItems, setHyperLinkItems] = useState([]);
  const addHyperLinkItem = () => {
    setHyperLinkItems([
      ...hyperLinkItems,
      ...[
        {
          id: Date.now(),
          openningOption: "_blank",
          linkedItemKey: "",
          reportId: "",
          parameterKeys: [],
        },
      ],
    ]);
  };

  useEffect(() => {
    if (editorState.selectedResource.drillDowns && editorState.selectedResource["drillDowns"].length > 0) {
      setHyperLinkItems(editorState.selectedResource.drillDowns);
    }
  }, [editorState]);

  const deleteHyperLinkItem = (item) => {
    setHyperLinkItems(hyperLinkItems.filter((hl) => hl.id !== item.id));
  };

  const handleChangeOpeningOption = (linkItem, val) => {
    setHyperLinkItems(
      hyperLinkItems.map((hl) => {
        return {
          ...hl,
          openningOption: hl.id === linkItem.id ? val : hl.openningOption,
        };
      }),
    );
  };

  const handleChangeLinkedParameter = (linkItem, val) => {
    setHyperLinkItems(
      hyperLinkItems.map((hl) => {
        return {
          ...hl,
          linkedItemKey: hl.id === linkItem.id ? val : hl.linkedItemKey,
        };
      }),
    );
  };

  const handleChangeReportName = (linkItem, val) => {
    setHyperLinkItems(
      hyperLinkItems.map((hl) => {
        return {
          ...hl,
          reportId: hl.id === linkItem.id ? val : hl.reportId,
        };
      }),
    );
  };

  const handleChangeRequestParameters = (linkItem, val) => {
    console.log("linkItem, val", linkItem, val);
    setHyperLinkItems(
      hyperLinkItems.map((hl) => {
        return {
          ...hl,
          parameterKeys: hl.id === linkItem.id ? val : hl.parameterKeys,
        };
      }),
    );
  };

  const handleSaveHyperlinks = () => {
    console.log("hyperLinkItems ===>>", hyperLinkItems);
    dispatch(updateDrillDowns(hyperLinkItems));
  };

  const clearHyperLinks = () => {
    setHyperLinkItems([]);
    dispatch(updateDrillDowns([]));
  };
  //   return (
  //     <div style={{ overflowY: "auto", height: "30vh" }}>
  //       <div style={{ display: "flex", alignItems: "center" }}>
  //         <div style={{ width: "100%" }}>
  //           {props.connectionType === "Rest API" ? (
  //             <>
  //               <Row>
  //                 <Col>
  //                   <b>HyperLinks</b>
  //                 </Col>
  //               </Row>

  //               {hyperLinkItems.map((item, i) => (
  //                 <Row key={"hyperlink_" + i} gutter={16} style={{ marginTop: "16px" }}>
  //                   <Col span={4}>
  //                     <div>Open in:</div>
  //                     <div>
  //                       <Select
  //                         style={{ width: "90%" }}
  //                         placeholder="Select Item to Link"
  //                         onChange={(val) => handleChangeOpeningOption(item, val)}
  //                         value={item.openningOption || "_blank"}
  //                       >
  //                         <Option value="_blank">New Tab</Option>
  //                         <Option value="_self">Same Tab</Option>
  //                       </Select>
  //                     </div>
  //                   </Col>
  //                   <Col span={4}>
  //                     <div>Parameter:</div>
  //                     <div>
  //                       <Select
  //                         style={{ width: "90%" }}
  //                         placeholder="Select Item to Link"
  //                         onChange={(val) => handleChangeLinkedParameter(item, val)}
  //                         value={item.linkedItemKey}
  //                       >
  //                         {editorState.selectedResource &&
  //                           editorState.selectedResource.availableFields &&
  //                           editorState.selectedResource.availableFields
  //                             .filter((f) => f.checked)
  //                             .map((af) => {
  //                               return (
  //                                 <Option key={af.id} value={af.fieldName}>
  //                                   {af.fieldName}
  //                                 </Option>
  //                               );
  //                             })}
  //                       </Select>
  //                     </div>
  //                   </Col>

  //                   <Col span={4}>
  //                     <div>Report Name:</div>
  //                     <div>
  //                       <Select
  //                         style={{ width: "90%" }}
  //                         placeholder="Select Report"
  //                         onChange={(val) => handleChangeReportName(item, val)}
  //                         value={item.reportId}
  //                       >
  //                         {boardsState.boardsData &&
  //                           boardsState.boardsData.map((bd) => {
  //                             return (
  //                               <Option key={bd.id} value={bd.id}>
  //                                 {bd.name}
  //                               </Option>
  //                             );
  //                           })}
  //                       </Select>
  //                     </div>
  //                   </Col>

  //                   <Col span={6}>
  //                     <div>Request Parameters:</div>
  //                     <div>
  //                       <Select
  //                         style={{ width: "90%" }}
  //                         placeholder="Parameters"
  //                         mode="multiple"
  //                         allowClear
  //                         onChange={(val) => handleChangeRequestParameters(item, val)}
  //                         value={item.parameterKeys}
  //                       >
  //                         {editorState.selectedResource &&
  //                           editorState.selectedResource.availableFields &&
  //                           editorState.selectedResource.availableFields.map((af) => {
  //                             return (
  //                               <Option key={af.id} value={af.fieldName}>
  //                                 {af.fieldName}
  //                               </Option>
  //                             );
  //                           })}
  //                       </Select>
  //                     </div>
  //                   </Col>
  //                   <Col span={1}>
  //                     <div>&nbsp;</div>
  //                     <div>
  //                       <Button type="text" icon={<CloseOutlined />} onClick={() => deleteHyperLinkItem(item)} />
  //                     </div>
  //                   </Col>
  //                 </Row>
  //               ))}

  //               <Row style={{ marginTop: "16px", marginBottom: "32px" }} gutter={16}>
  //                 <Col span={5}>
  //                   <Button onClick={addHyperLinkItem}>Add New +</Button>
  //                 </Col>
  //               </Row>
  //               <hr />
  //               <Row style={{ marginTop: "16px", marginBottom: "32px" }} gutter={16}>
  //                 <Col span={5}>
  //                   <Button type="primary" onClick={handleSaveHyperlinks}>
  //                     Save
  //                   </Button>
  //                 </Col>
  //                 <Col span={5}>
  //                   <Button onClick={clearHyperLinks}>Clear</Button>
  //                 </Col>
  //               </Row>
  //             </>
  //           ) : null}
  //         </div>
  //       </div>
  //     </div>
  //   );

  return (
    <div className="hyperlink-wrapper">
      {props.connectionType === "Rest API" ? (
        <>
          {hyperLinkItems.map((item, i) => (
            <div key={"hyperlink_" + i} className="hyperlink-row">
              {/* Row 1: Open in + Parameter + Report Name */}
              <div className="hyperlink-row-grid">
                <div className="hyperlink-field">
                  <label>Open in</label>
                  <Select
                    value={item.openningOption || "_blank"}
                    onChange={(val) => handleChangeOpeningOption(item, val)}
                  >
                    <Option value="_blank">New Tab</Option>
                    <Option value="_self">Same Tab</Option>
                  </Select>
                </div>

                <div className="hyperlink-field">
                  <label>Parameter</label>
                  <Select
                    placeholder="Select"
                    value={item.linkedItemKey}
                    onChange={(val) => handleChangeLinkedParameter(item, val)}
                  >
                    {editorState.selectedResource?.availableFields
                      ?.filter((f) => f.checked)
                      .map((af) => (
                        <Option key={af.id} value={af.fieldName}>
                          {af.fieldName}
                        </Option>
                      ))}
                  </Select>
                </div>

                <div className="hyperlink-field">
                  <label>Report Name</label>
                  <Select
                    placeholder="Select Report"
                    value={item.reportId}
                    onChange={(val) => handleChangeReportName(item, val)}
                  >
                    {boardsState.boardsData?.map((bd) => (
                      <Option key={bd.id} value={bd.id}>
                        {bd.name}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>

              {/* Row 2: Request Parameters + Remove */}
              <div className="hyperlink-field-full">
                <div className="hyperlink-field">
                  <label>Request Parameters</label>
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="Parameters"
                    value={item.parameterKeys}
                    onChange={(val) => handleChangeRequestParameters(item, val)}
                  >
                    {editorState.selectedResource?.availableFields?.map((af) => (
                      <Option key={af.id} value={af.fieldName}>
                        {af.fieldName}
                      </Option>
                    ))}
                  </Select>
                </div>
                <Button className="filter-remove-btn" onClick={() => deleteHyperLinkItem(item)}>
                  <img src={DeleteIcon} alt="delete-icon" /> Remove Remove
                </Button>
              </div>
            </div>
          ))}

          <Button type="link" className="hyperlink-add-btn" onClick={addHyperLinkItem}>
            + Add New
          </Button>

          <div className="hyperlink-actions">
            <Button type="primary" onClick={handleSaveHyperlinks}>
              Save
            </Button>
            <Button onClick={clearHyperLinks}>Clear</Button>
          </div>
        </>
      ) : null}
    </div>
  );
}
